import * as React from "react";
import Dialog from "@material-ui/core/Dialog";
import "./index.scss";
import { makeStyles } from "@material-ui/core/styles";
import ThankyouImage from "../../images/pray.svg";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("xs")]: {
      alignItems: "flex-end", // push the dialog to bottom
    },
  },
  paper: {
    // make the content full width
    [theme.breakpoints.down("xs")]: {
      margin: 0,
      maxWidth: "100%",
      width: "100%",
      overflow: "hidden",
      borderTopLeftRadius: "30px",
      borderTopRightRadius: "30px",
    },
  },
}));

export default function FeedbackDialog({ onClose }) {
  const classes = useStyles();
  return (
    <Dialog
      open={true}
      classes={{ container: classes.root, paper: classes.paper }}
    >
      <div className="dialog-container">
        <img src={ThankyouImage} alt="pray" loading="lazy" />

        <h1>Thank You</h1>
        <p>for giving your feedback</p>

        <button
          className="submit-btn"
          style={{ width: "360px", marginTop: "50px" }}
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </Dialog>
  );
}
